// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__Npj06","table":"Table_table__dR9e3","row":"Table_row__5NW3i","col":"Table_col__PyJrf"};